import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import privateUserService from "../Services/Service";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Button,
  Paper,
  Modal,
  Box,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Autocomplete,
} from "@mui/material";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from "@mui/material";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PrivateUserManager = () => {
  const [privateUsers, setPrivateUsers] = useState([]);
  const [form, setForm] = useState({
    id: "0",
    email: "",
  });

  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  useEffect(() => {
    privateUserService.setApiUrl(
      sessionStorage.getItem("APIUrl") + "/api/PrivateUser",
    );
    //categoryService.setApiUrl("https://localhost:7106/api/Category");
    fetchPrivateUsers();
    fetchEmployeeEmails();
  }, []);

  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchPrivateUsers = async () => {
    const res = await privateUserService.getAll();
    setPrivateUsers(res.data);
  };

  const fetchEmployeeEmails = async () => {
    try {
      // Temporarily use UserMapping API
      privateUserService.setApiUrl(
        sessionStorage.getItem("APIUrl") + "/api/UserMapping",
      );

      const res = await privateUserService.loadUsername(0, "EmployeeEmail");

      setEmployeeList(res.data);

      // IMPORTANT: change back to PrivateUser API
      privateUserService.setApiUrl(
        sessionStorage.getItem("APIUrl") + "/api/PrivateUser",
      );
    } catch (error) {
      console.error("Error loading employee emails:", error);

      // Also restore PrivateUser API if there is an error
      privateUserService.setApiUrl(
        sessionStorage.getItem("APIUrl") + "/api/PrivateUser",
      );
    }
  };

  const clear = () => {
    setForm({ id: "0", email: "" });
    setSelectedEmployee(null);
    setEditing(false);
  };

const handleBlur = () => {
  // Do nothing on blur
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = form.email.trim();

  // 1. Required validation
  if (!email) {
    setSnackbar({
      open: true,
      message: "Email is required",
      severity: "error",
    });
    return;
  }

  // 2. Duplicate email validation - case insensitive
  // Exclude the current record during edit
  const duplicate = privateUsers.some(
    (user) =>
      user.email?.trim().toLowerCase() === email.toLowerCase() &&
      String(user.id) !== String(form.id)
  );

  if (duplicate) {
    setSnackbar({
      open: true,
      message: "Email already exists",
      severity: "error",
    });
    return;
  }

    try {
      const response = await privateUserService.create({
        ID: form.id,

        Email: form.email,
        OpFlag: editing ? "Update" : "Insert",
      });
      let vOutput = response.data.message.split(":");
      clear();
      fetchPrivateUsers();
      setOpen(false);
      setSnackbar({
        open: true,
        //message: editing ? "Private user updated successfully!" : "Private user added successfully!",
        message: vOutput[0],
        severity: vOutput[1],
      });
    } catch (error) {
      console.error("Error saving private user:", error);
    }
  };

  const handleEdit = (user) => {
    setForm({
      id: user.id,
      email: user.email,
    });

    const employee = employeeList.find(
      (emp) => emp.empEmail?.toLowerCase() === user.email?.toLowerCase(),
    );

    setSelectedEmployee(employee || null);

    setEditing(true);
    setOpen(true);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };
  const confirmDelete = async () => {
    try {
      const response = await privateUserService.remove(deleteId, "Delete");
      let vOutput = response.data.message.split(":");
      fetchPrivateUsers();
      setSnackbar({
        open: true,
        message: vOutput[1],
        severity: vOutput[0],
      });
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Error deleting private user !",
        severity: "error",
      });
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const handleAddClick = () => {
    clear();
    setOpen(true);
  };

  // Columns for MUI DataGrid
  const columns = [
    {
      field: "serialNo",
      headerName: "No.",
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },

    { field: "id", headerName: "ID" },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: true,
    },
    {
      field: "createdOn",
      headerName: "Created On",
      flex: 1,
      renderCell: (params) => {
        if (!params.value) return "";

        const date = new Date(params.value);

        return date.toLocaleDateString("en-GB");
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 220,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            height: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<ModeEditOutlineRoundedIcon />}
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<DeleteRoundedIcon />}
            onClick={() => handleDelete(params.row.id)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="privateuser-grid-wrapper">
      <Box
        sx={{
          mt: 4,
          bgcolor: "background.paper", // white/light background
          borderRadius: 3, // rounded corners
          boxShadow: 6, // floating shadow
          p: 4, // inner padding
          border: "1px solid rgba(0,0,0,0.12)", // subtle border
          width: "100%",
          overflow: "auto",
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/DashboardFinal")}
          >
            Back to Home
          </Button>
          <Button variant="contained" onClick={handleAddClick}>
            Add Private User
          </Button>
        </Box>

        {/* DataGrid wrapper */}
        <div className="datagrid-container">
          <DataGrid
            rows={privateUsers}
            columns={columns}
            columnVisibilityModel={{
              id: false,
            }}
            getRowId={(row) => row.id}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
            components={{ Toolbar: GridToolbar }}
            sx={{
              "& .MuiDataGrid-root": {
                fontSize: "0.875rem",
              },
              "& .MuiDataGrid-cell": {
                padding: "8px 12px",
              },

              "& .MuiDataGrid-columnHeader": {
                padding: "8px 4px",
              },
              "@media (max-width: 768px)": {
                "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
                  padding: "6px 2px",
                  fontSize: "0.75rem",
                },
              },
              "@media (max-width: 480px)": {
                "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader": {
                  padding: "4px 2px",
                  fontSize: "0.7rem",
                },
              },
            }}
          />
        </div>

        {/* Modal */}
        <Modal open={open} onClose={() => setOpen(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              width: 400,
            }}
          >
            <h4>{editing ? "Edit" : "Add"} Private User</h4>
            <form onSubmit={handleSubmit}>
              <Autocomplete
                fullWidth
                options={employeeList}
                value={selectedEmployee}
                getOptionLabel={(option) => option.empEmail || ""}
                isOptionEqualToValue={(option, value) =>
                  option.empNo === value.empNo
                }
                onChange={(event, newValue) => {
                  setSelectedEmployee(newValue);

                  setForm((prev) => ({
                    ...prev,
                    email: newValue?.empEmail || "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Email" required />
                )}
                sx={{ mb: 2 }}
              />
              <Box display="flex" justifyContent="flex-end">
                <Button onClick={() => setOpen(false)} sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained">
                  {editing ? "Update" : "Add"}
                </Button>
              </Box>
            </form>
          </Box>
        </Modal>

        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>

        {/* Confirm Dialog */}
        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
          <DialogTitle>{"Confirm Deletion"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this private user?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={confirmDelete}
              color="error"
              variant="contained"
              autoFocus
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </div>
  );
};
export default PrivateUserManager;
